import setAsset from '../base-saving-actions/set-asset';

const updateAssets = (assetsToUpdate) =>
  assetsToUpdate.map(({ source, content = null }) => setAsset(source, { content }));

export default updateAssets;
